(() => {
  const collectionCopy = {
    'home-gym': ['Kompakte Home-Gym Auswahl', 'Stabile Basics fuer dein Training zuhause: platzsparend, klar sortiert und schnell vergleichbar.', ['Zuhause trainieren','Setup erweitern','Schnell vergleichen']],
    'griffkraft-training': ['Griffkraft gezielt staerken', 'Tools fuer Haende, Unterarme und kontrollierte Progression. Ideal fuer Kraftsport, Klettern und funktionelles Training.', ['Haende & Unterarme','Progression','Zubehoer']],
    'boxtraining': ['Boxtraining zuhause starten', 'Equipment fuer Technik, Kondition und Reflexe mit sauberer Produktauswahl.', ['Kondition','Technik','Reflexe']],
    'fitness-zubehor': ['Zubehoer fuer dein Setup', 'Ergaenze dein Training mit funktionellen Helfern fuer Alltag, Studio und Home-Gym.', ['Alltag & Gym','Ergaenzung','Praktisch']],
    'krafttraining': ['Krafttraining klar aufgebaut', 'Ausgewaehlte Produkte fuer Widerstand, Stabilitaet und strukturierte Workouts.', ['Kraft','Stabilitaet','Routine']],
    'ausdauer-conditioning': ['Ausdauer & Conditioning', 'Produkte fuer Cardio, Core und intensive Einheiten mit klarem Trainingsfokus.', ['Ausdauer','Core','Conditioning']],
    'bestseller': ['Beliebte Produkte', 'Eine schnelle Auswahl der Produkte, die fuer viele Trainingsziele besonders relevant sind.', ['Beliebt','Schnell gefunden','Top Auswahl']]
  };

  function installBadgeStyles() {
    if (document.getElementById('slq-sale-badge-fix')) return;
    const style = document.createElement('style');
    style.id = 'slq-sale-badge-fix';
    style.textContent = `
      .product-card::after,
      product-card::after,
      .resource-card::after { content: none !important; display: none !important; }
      .product-card .product-badges:empty,
      .resource-card .product-badges:empty,
      product-card .product-badges:empty { display: none !important; }
      .product-card .card-gallery::before,
      .resource-card .card-gallery::before,
      product-card .card-gallery::before { content: none !important; display: none !important; }
      @media (max-width: 749px) {
        html, body { max-width: 100% !important; overflow-x: hidden !important; }
        .product-information,
        .product-details,
        .product-information__grid,
        product-info,
        product-form-component,
        .product-form { max-width: 100% !important; min-width: 0 !important; overflow-wrap: anywhere !important; }
        .product-details h1,
        .product-information h1,
        .product-title,
        h1.product-title { max-width: 100% !important; width: 100% !important; overflow-wrap: anywhere !important; word-break: normal !important; hyphens: auto !important; font-size: clamp(2rem, 9vw, 2.65rem) !important; line-height: .98 !important; }
        media-gallery,
        slideshow-component,
        slideshow-container,
        slideshow-slides,
        slideshow-slide,
        .product-media,
        .product-media-container { max-width: 100% !important; min-width: 0 !important; overflow: hidden !important; }
        .product-media img,
        .product-media__image { max-width: 100% !important; height: auto !important; object-fit: contain !important; object-position: center !important; }
        .sl-cro-trustbar,
        .sl-legal-strip { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; width: 100% !important; max-width: 100% !important; min-height: 0 !important; max-height: none !important; overflow: hidden !important; border-top: 1px solid rgba(255,255,255,.12) !important; border-bottom: 1px solid rgba(255,255,255,.08) !important; }
        .sl-cro-trustbar > *,
        .sl-legal-strip > *,
        .sl-cro-trustbar a,
        .sl-legal-strip a { min-width: 0 !important; min-height: 42px !important; padding: 10px 8px !important; font-size: 11px !important; line-height: 1.15 !important; text-align: center !important; white-space: normal !important; }
        .slx-announcement { display: flex !important; align-items: center !important; gap: 18px !important; width: 100% !important; max-width: 100vw !important; overflow-x: auto !important; white-space: nowrap !important; padding: 10px 16px !important; scrollbar-width: none !important; }
        .slx-announcement::-webkit-scrollbar,
        .slx-quicknav::-webkit-scrollbar { display: none !important; }
        .slx-quicknav { width: 100% !important; max-width: 100% !important; overflow-x: auto !important; padding-inline: 0 !important; }
        .slx-quicknav a { white-space: nowrap !important; }
        .slx-shell { width: min(100% - 32px, 1440px) !important; }
        html[data-sl-theme='light'],
        html[data-sl-theme='light'] body,
        html[data-sl-theme='light'] #MainContent,
        html[data-sl-theme='light'] .content-for-layout,
        html[data-sl-theme='light'] .slx-home,
        html[data-sl-theme='light'] .section-wrapper { background: #f4f5f1 !important; color: #121312 !important; }
        html[data-sl-theme='light'] .header-section,
        html[data-sl-theme='light'] .header { background: rgba(255,255,255,.96) !important; color: #121312 !important; border-color: rgba(18,19,18,.14) !important; }
        html[data-sl-theme='light'] .header a,
        html[data-sl-theme='light'] .header button,
        html[data-sl-theme='light'] .header svg { color: #121312 !important; }
        html[data-sl-theme='light'] .sl-cro-trustbar,
        html[data-sl-theme='light'] .sl-legal-strip { background: #e9ece2 !important; color: #171817 !important; border-color: rgba(18,19,18,.14) !important; }
        html[data-sl-theme='light'] .slx-announcement { background: #121312 !important; color: #e7ff38 !important; }
        html[data-sl-theme='light'] .slx-heading h2,
        html[data-sl-theme='light'] .slx-heading p,
        html[data-sl-theme='light'] .slx-link,
        html[data-sl-theme='light'] .slx-footer-note,
        html[data-sl-theme='light'] .slx-goal { color: #121312 !important; }
        html[data-sl-theme='light'] .slq-collection-hero,
        html[data-sl-theme='light'] .facets-controls-wrapper,
        html[data-sl-theme='light'] .facets__form-wrapper { background: #ffffff !important; color: #121312 !important; border-color: rgba(18,19,18,.12) !important; }
        html[data-sl-theme='light'] .slq-collection-hero h1,
        html[data-sl-theme='light'] .slq-collection-hero p,
        html[data-sl-theme='light'] main h1,
        html[data-sl-theme='light'] main h2 { color: #121312 !important; }
        html[data-sl-theme='light'] .product-details { background: #ffffff !important; color: #121312 !important; border-color: rgba(18,19,18,.12) !important; }
        html[data-sl-theme='light'] .product-details h1,
        html[data-sl-theme='light'] .product-details .price,
        html[data-sl-theme='light'] .product-details .price * { color: #121312 !important; }
        html[data-sl-theme='light'] .sl-product-promise > div,
        html[data-sl-theme='light'] .sl-product-info-box,
        html[data-sl-theme='light'] .slq-product-description { background: #fff !important; color: #242624 !important; border-color: rgba(18,19,18,.12) !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function addCollectionHero() {
    const match = location.pathname.match(/^\/collections\/([^/?#]+)/);
    if (!match || document.querySelector('.slq-collection-hero')) return;
    const handle = match[1];
    const data = collectionCopy[handle] || ['Produkte entdecken','Finde passende Trainingsprodukte in dieser Kategorie.', ['Auswahl','Training','Equipment']];
    const target = document.querySelector('.collection-wrapper, main .section, main');
    if (!target) return;
    const hero = document.createElement('section');
    hero.className = 'slq-collection-hero slq-wrap';
    hero.innerHTML = `<div class="slq-collection-hero__top"><div><span class="sl-cro-eyebrow">Shop nach Ziel</span><h1>${data[0]}</h1><p>${data[1]}</p></div></div><div class="slq-collection-tags">${data[2].map((item) => `<span>${item}</span>`).join('')}</div>`;
    target.prepend(hero);
  }

  function polishProductPage() {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (!template.includes('product')) return;
    const title = document.querySelector('.product-details h1');
    if (title && !document.querySelector('.slq-product-kicker')) {
      const kicker = document.createElement('span');
      kicker.className = 'sl-cro-eyebrow slq-product-kicker';
      kicker.textContent = 'StrengthLab One Auswahl';
      title.before(kicker);
    }
    const description = Array.from(document.querySelectorAll('.product-details .rte, .product-details [class*="text"]')).find((el) => (el.textContent || '').trim().length > 80 && !el.closest('.sl-product-info-box'));
    if (description && !description.classList.contains('slq-product-description')) {
      description.classList.add('slq-product-description');
    }
  }

  function removeSaleBadges() {
    document.querySelectorAll('.product-card, .resource-card, product-card, .slx-card').forEach((card) => {
      card.querySelectorAll('[class*="badge"], [class*="Badge"], [class*="sale"], [class*="Sale"], span, div').forEach((node) => {
        if (node.children.length > 0) return;
        const label = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (label === 'sale') node.remove();
      });
    });
  }

  function polishCards() {
    document.querySelectorAll('.product-card, .resource-card').forEach((card) => {
      if (card.dataset.slqPolished) return;
      card.dataset.slqPolished = 'true';
      card.setAttribute('data-quality-card', 'true');
    });
    removeSaleBadges();
  }

  function observeProductGrid() {
    const target = document.querySelector('main') || document.body;
    if (!target || target.dataset.slqBadgeObserver) return;
    target.dataset.slqBadgeObserver = 'true';
    const observer = new MutationObserver(() => removeSaleBadges());
    observer.observe(target, { childList: true, subtree: true });
  }

  function run() {
    installBadgeStyles();
    addCollectionHero();
    polishProductPage();
    polishCards();
    observeProductGrid();
    window.setTimeout(polishCards, 300);
    window.setTimeout(polishCards, 800);
    window.setTimeout(polishCards, 1600);
    window.setTimeout(removeSaleBadges, 2800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
